module.exports = __webpack_public_path__ + "static/media/calender-icon.415b12c4.svg";